import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CALENDARIO_EXAMENES, ETAPAS_RUTA_ASPIRANTE } from '../data/examDatesData';
import { useAuth } from '../hooks/useAuth';

const CalendarioExamenes = () => {
  const { profileData } = useAuth();
  const [activeTab, setActiveTab] = useState('todos'); // 'todos' | 'tu_universidad' | 'uninav' | 'otono' | 'estatal'
  const [showRoadmap, setShowRoadmap] = useState(true);

  const userUnivId = profileData?.universidadId || '';
  const userUnivNombre = profileData?.universidadNombre || profileData?.universidadAbreviatura || '';
  const userCarreraNombre = profileData?.carreraNombre || '';

  // Encontrar examen específico de la universidad del usuario si existe
  const examenUsuario = CALENDARIO_EXAMENES.find(e => 
    (userUnivId && e.universidadId === userUnivId) || 
    (userUnivNombre && e.institucion.toLowerCase().includes(userUnivNombre.toLowerCase()))
  ) || (userUnivId === 'UNINAV' ? CALENDARIO_EXAMENES[0] : null);

  // Filtrado de exámenes según pestaña activa
  const examenesFiltrados = CALENDARIO_EXAMENES.filter(item => {
    if (activeTab === 'tu_universidad') {
      return (userUnivId && item.universidadId === userUnivId) || 
             (userUnivNombre && item.institucion.toLowerCase().includes(userUnivNombre.toLowerCase()));
    }
    if (activeTab === 'uninav') return item.tipo === 'uninav';
    if (activeTab === 'otono') return item.tipo === 'otono';
    if (activeTab === 'estatal') return item.tipo === 'estatal';
    return true;
  });

  return (
    <section className="calendario-examenes-section" style={{ marginBottom: '2.5rem' }}>
      {/* Encabezado del Calendario */}
      <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          background: 'rgba(197, 160, 89, 0.12)',
          border: '1px solid rgba(197, 160, 89, 0.35)',
          padding: '4px 14px',
          borderRadius: '20px',
          fontSize: '0.8rem',
          color: '#e2ba6f',
          fontWeight: 600,
          marginBottom: '10px'
        }}>
          <span>📅 Calendario Ceneval & Universidades</span>
          <span style={{ color: '#94a3b8' }}>•</span>
          <span style={{ color: '#38bdf8' }}>📍 Estamos en Septiembre</span>
        </div>
        <h2 style={{
          fontSize: 'clamp(1.4rem, 3vw, 1.8rem)',
          fontWeight: 700,
          color: '#f8fafc',
          margin: '0 0 8px 0',
          letterSpacing: '0.02em'
        }}>
          Próximas Fechas de Exámenes de Ingreso EXANI-II
        </h2>
        <p style={{
          fontSize: '0.92rem',
          color: '#94a3b8',
          maxWidth: '740px',
          margin: '0 auto',
          lineHeight: 1.6
        }}>
          Conoce cuándo se publican las convocatorias, fechas de registro y periodos de aplicación del examen nacional EXANI-II para planificar tus sesiones de estudio.
        </p>
      </div>

      {/* Tarjeta Destacada: Universidad del Usuario (si está configurada) */}
      {examenUsuario && (
        <div style={{
          background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.15) 0%, rgba(10, 26, 42, 0.85) 100%)',
          border: '1px solid rgba(56, 189, 248, 0.45)',
          borderRadius: '14px',
          padding: '1.5rem',
          marginBottom: '1.75rem',
          boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
          textAlign: 'left'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '46px',
                height: '46px',
                borderRadius: '12px',
                background: 'rgba(56, 189, 248, 0.25)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.6rem',
                border: '1px solid #38bdf8'
              }}>
                {examenUsuario.universidadId === 'UNINAV' ? '⚓' : '🎓'}
              </div>
              <div>
                <div style={{ fontSize: '0.75rem', fontWeight: 700, color: '#38bdf8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  ⭐ Fechas clave para tu institución seleccionada
                </div>
                <h3 style={{ margin: '2px 0 0 0', fontSize: '1.25rem', color: '#f8fafc', fontWeight: 700 }}>
                  {examenUsuario.institucion}
                </h3>
                {userCarreraNombre && (
                  <div style={{ fontSize: '0.82rem', color: '#cbd5e1', marginTop: '2px' }}>
                    Aspirante a: <strong style={{ color: '#7dd3fc' }}>{userCarreraNombre}</strong>
                  </div>
                )}
              </div>
            </div>

            <span style={{
              background: 'rgba(197, 160, 89, 0.2)',
              border: '1px solid #c5a059',
              color: '#f5e6c8',
              padding: '6px 14px',
              borderRadius: '20px',
              fontSize: '0.8rem',
              fontWeight: 700
            }}>
              {examenUsuario.estadoLabel}
            </span>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            gap: '12px',
            background: 'rgba(0, 0, 0, 0.25)',
            padding: '1rem',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.06)'
          }}>
            <div>
              <span style={{ fontSize: '0.72rem', color: '#94a3b8', textTransform: 'uppercase', display: 'block' }}>📢 Convocatoria</span>
              <strong style={{ fontSize: '0.92rem', color: '#f1f5f9' }}>{examenUsuario.fechaConvocatoria}</strong>
            </div>
            <div>
              <span style={{ fontSize: '0.72rem', color: '#94a3b8', textTransform: 'uppercase', display: 'block' }}>📝 Registro en Línea</span>
              <strong style={{ fontSize: '0.92rem', color: '#f1f5f9' }}>{examenUsuario.fechaRegistro}</strong>
            </div>
            <div>
              <span style={{ fontSize: '0.72rem', color: '#38bdf8', textTransform: 'uppercase', display: 'block', fontWeight: 700 }}>🎯 Fecha de Examen</span>
              <strong style={{ fontSize: '1.05rem', color: '#38bdf8' }}>{examenUsuario.fechaExamen}</strong>
            </div>
            <div>
              <span style={{ fontSize: '0.72rem', color: '#94a3b8', textTransform: 'uppercase', display: 'block' }}>🏆 Resultados</span>
              <strong style={{ fontSize: '0.92rem', color: '#f1f5f9' }}>{examenUsuario.resultados}</strong>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px', marginTop: '1rem' }}>
            <p style={{ margin: 0, fontSize: '0.78rem', color: '#94a3b8', lineHeight: 1.4, maxWidth: '650px' }}>
              💡 <em>{examenUsuario.notas}</em>
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              {examenUsuario.enlaceOficial && (
                <a
                  href={examenUsuario.enlaceOficial}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    background: 'rgba(56, 189, 248, 0.12)',
                    border: '1px solid rgba(56, 189, 248, 0.4)',
                    color: '#7dd3fc',
                    padding: '8px 14px',
                    borderRadius: '8px',
                    fontWeight: 600,
                    fontSize: '0.8rem',
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}
                >
                  🌐 Portal Oficial ↗
                </a>
              )}
              <Link
                to="/dashboard/simulador"
                style={{
                  background: 'linear-gradient(135deg, #c5a059 0%, #dbb96a 100%)',
                  color: '#0a1a2a',
                  padding: '8px 18px',
                  borderRadius: '8px',
                  fontWeight: 700,
                  fontSize: '0.82rem',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                🚀 Entrenar en el Simulador
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Ruta / Cronograma de Preparación (Roadmap del Aspirante) */}

        <div style={{ textAlign: 'center', marginTop: '1.25rem' }}>
        <Link
          to="/universidades-convocatorias"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: 'linear-gradient(135deg, #c5a059 0%, #dbb96a 100%)',
            color: '#0a1a2a',
            padding: '12px 22px',
            borderRadius: '10px',
            fontWeight: 900,
            fontSize: '2rem',
            textDecoration: 'none',
            boxShadow: '0 9px 18px rgba(0,0,0,0.25)'
          }}
        >
          🎓 Ver todas las universidades y convocatorias
        </Link>
      </div>

      <div style={{
        background: 'rgba(10, 26, 42, 0.75)',
        border: '1px solid rgba(197, 160, 89, 0.2)',
        borderRadius: '14px',
        padding: '1.25rem 1.5rem',
        marginBottom: '1.75rem',
        textAlign: 'left'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '1.2rem' }}>🧭</span>
            <h3 style={{ margin: 0, fontSize: '1.05rem', color: '#f5e6c8', fontWeight: 700 }}>
              Cronograma Estratégico del Aspirante EXANI-II
            </h3>
          </div>
          <button
            type="button"
            onClick={() => setShowRoadmap(!showRoadmap)}
            style={{
              background: 'none',
              border: 'none',
              color: '#94a3b8',
              cursor: 'pointer',
              fontSize: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            {showRoadmap ? 'Ocultar ruta ▲' : 'Ver ruta ▼'}
          </button>
        </div>

        {showRoadmap && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
            gap: '12px'
          }}>
            {ETAPAS_RUTA_ASPIRANTE.map((etapa) => (
              <div
                key={etapa.etapa}
                style={{
                  background: etapa.activo 
                    ? 'linear-gradient(135deg, rgba(56, 189, 248, 0.15) 0%, rgba(10, 26, 42, 0.8) 100%)' 
                    : 'rgba(255, 255, 255, 0.02)',
                  border: etapa.activo ? '1px solid #38bdf8' : '1px solid rgba(255, 255, 255, 0.07)',
                  borderRadius: '10px',
                  padding: '1rem',
                  position: 'relative'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                  <span style={{
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    padding: '2px 8px',
                    borderRadius: '12px',
                    background: etapa.activo ? '#38bdf8' : 'rgba(255,255,255,0.08)',
                    color: etapa.activo ? '#0a1a2a' : '#94a3b8'
                  }}>
                    Etapa {etapa.etapa}
                  </span>
                  <span style={{ fontSize: '0.72rem', color: etapa.activo ? '#7dd3fc' : '#64748b', fontWeight: 600 }}>
                    {etapa.badge}
                  </span>
                </div>
                <div style={{ fontSize: '0.88rem', fontWeight: 700, color: etapa.activo ? '#f8fafc' : '#cbd5e1', marginBottom: '2px' }}>
                  {etapa.meses}
                </div>
                <div style={{ fontSize: '0.78rem', fontWeight: 600, color: etapa.activo ? '#38bdf8' : '#e2ba6f', marginBottom: '6px' }}>
                  {etapa.titulo}
                </div>
                <p style={{ margin: 0, fontSize: '0.73rem', color: '#94a3b8', lineHeight: 1.4 }}>
                  {etapa.descripcion}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

    
    </section>
  );
};

export default CalendarioExamenes;

